import type { ResizeOptions } from './resize-media-url.js';
import { resizeMediaUrl } from './resize-media-url.js';

export const fullscreenResizeMediaUrl = (params: ResizeOptions) =>
  resizeMediaUrl({
    ...params,
    requiredWidth: params.requiredWidth * 2,
    requiredHeight: params.requiredHeight * 2,
  });
